import { AddressPoint } from '@/models';

export interface AddressState {
  address: AddressPoint | null
}

export const InitialState: AddressState = {
  address: null
}
